var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70117 10.9219H12.5973V25.4347H8.70117V10.9219Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4033 13.999H19.2994V25.4349H15.4033V13.999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1045 8.56348H26.0006V25.4352H22.1045V8.56348Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.4092H5.8961V25.4348H2V16.4092Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.917 1.43555C22.8276 1.43555 21.9445 2.30678 21.9445 3.38149C21.9445 3.63303 21.9934 3.87318 22.0815 4.09385L18.2797 7.29092C18.0008 7.14185 17.6812 7.05718 17.3417 7.05718C16.7779 7.05718 16.2698 7.29087 15.9103 7.66497L12.6284 6.3381C12.6287 6.32554 12.6294 6.31308 12.6294 6.30041C12.6294 5.2257 11.7462 4.35447 10.6568 4.35447C9.56733 4.35447 8.68421 5.2257 8.68421 6.30041C8.68421 6.40918 8.69367 6.51569 8.71107 6.61959L5.30146 8.60969C4.96572 8.34856 4.54224 8.19231 4.08151 8.19231C2.99206 8.19231 2.10889 9.06354 2.10889 10.1383C2.10889 11.213 2.99206 12.0842 4.08151 12.0842C5.17096 12.0842 6.05408 11.213 6.05408 10.1383C6.05408 10.0295 6.04463 9.92297 6.02722 9.81907L9.43683 7.82897C9.77257 8.0901 10.1961 8.24636 10.6568 8.24636C11.2206 8.24636 11.7288 8.01267 12.0883 7.63856L15.3701 8.96543C15.3699 8.978 15.3691 8.99046 15.3691 9.00307C15.3691 10.0778 16.2523 10.949 17.3418 10.949C18.4312 10.949 19.3143 10.0778 19.3143 9.00307C19.3143 8.7779 19.2751 8.56184 19.2038 8.36066L23.0475 5.12826C23.3099 5.25559 23.6049 5.32744 23.9171 5.32744C25.0065 5.32744 25.8897 4.45621 25.8897 3.38149C25.8897 2.30678 25.0065 1.43555 23.917 1.43555Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsW);
export default __webpack_public_path__ + "static/media/reports_w.de7de48262da61bcf48778c972817d1b.svg";
export { ForwardRef as ReactComponent };